import { ApplicationSettings } from '../../../models/settings';
import RichTextComponentModel from '../../../models/components/rich-text-component-model';
import BaseComponentModel from '../../../models/components/base-component-model';
import ImageComponentModel from '../../../models/components/image-component-model';
import HeroComponentModel from '../../../models/components/hero-component-model';
import VideoComponentModel from '../../../models/components/video-component-model';
import CardSetComponentModel from '../../../models/components/card-set-component-model';
import CtaComponentModel from '../../../models/components/cta-component-model';
import MediaGalleryComponentModel from '../../../models/components/media-gallery-component-model';
import CarouselComponentModel from '../../../models/components/carousel-component-model';
import ComparisonCarouselComponentModel from '../../../models/components/comparison-carousel-component-model';
import MapComponentModel from '../../../models/components/map-component-model';
import AccordionSetComponentModel from '../../../models/components/accordion-set-component-model';
import CtaButtonComponentModel from '../../../models/components/cta-button-component-model';
import AdvertBannerComponentModel from '../../../models/components/advert-banner-component-model';
import CtaCardSetComponentModel from '../../../models/components/cta-card-set-component.model';
import IReason from '../../../api-clients/IReason';
import CtaHeroComponentModel from '../../../models/components/cta-hero-component-model';
import TestimonialCardSetComponentModel from '../../../models/components/testimonial-card-set-component.model';
import SearchBarComponentModel from '../../../models/components/searchbar-component-model';
import SpacerComponentModel from '../../../models/components/spacer-component-model';
import ApplicationFeeComponentModel from '../../../models/components/applicaton-fee-component-model';
import PricingBlockComponentModel from '../../../models/components/pricing-block-component-model';
export class ComponentListBuilder {
  page: string = null;
  constructor(page?: string) {
    if (page) {
      this.page = page;
    }
  }

  private components: BaseComponentModel[] = [];

  public addComponent(data: any, appSettings: ApplicationSettings): ComponentListBuilder {
    const contentType = data?.sys?.contentType?.sys?.id;

    if (contentType) {
      this.components.push(this.getComponentModel(contentType, data, appSettings));
    }

    return this;
  }

  public build(): BaseComponentModel[] {
    return this.components.filter(Boolean).filter((x) => x.isValid);
  }

  public getExclusions(): IReason[] {
    let reasons = [];
    this.components.filter(Boolean).forEach((a) => reasons.push(...a.exclusionReasons));
    return reasons;
  }

  private getComponentModel(
    contentType: string,
    data: any,
    appSettings: ApplicationSettings,
  ): BaseComponentModel {
    if (contentType === `componentRichText`) {
      return new RichTextComponentModel(data.fields, appSettings);
    } else if (contentType === `componentImage`) {
      return new ImageComponentModel(data.fields, appSettings);
    } else if (contentType === `componentHeroOrdered`) {
      return new HeroComponentModel(data.fields, appSettings);
    } else if (contentType === `componentVideo`) {
      return new VideoComponentModel(data.fields, appSettings);
    } else if (contentType === `componentCardSet`) {
      return new CardSetComponentModel(data.fields, appSettings);
    } else if (contentType === `componentCtaV2`) {
      return new CtaComponentModel(data.fields, appSettings);
    } else if (contentType === `componentMediaGallery`) {
      return new MediaGalleryComponentModel(data.fields, appSettings);
    } else if (contentType === `componentMap`) {
      return new MapComponentModel(data.fields, appSettings);
    } else if (contentType === `componentCarousel`) {
      return new CarouselComponentModel(data.fields, appSettings);
    } else if (contentType === `componentComparisonCarousel`) {
      return new ComparisonCarouselComponentModel(data.fields, appSettings);
    } else if (contentType === `componentAccordionSet`) {
      return new AccordionSetComponentModel(data.fields, appSettings);
    } else if (contentType === `componentButton`) {
      return new CtaButtonComponentModel(data.fields, appSettings);
    } else if (contentType === `componentAdvertBanner`) {
      return new AdvertBannerComponentModel(data.fields, appSettings);
    } else if (contentType === `componentCtaCardSet`) {
      return new CtaCardSetComponentModel(data.fields, appSettings);
    } else if (contentType === `componentCtaHero`) {
      return new CtaHeroComponentModel(data.fields, appSettings);
    } else if (contentType === `componentTestimonialCardSet`) {
      return new TestimonialCardSetComponentModel(data.fields, appSettings);
    } else if (contentType === `componentSearchBar`) {
      return new SearchBarComponentModel(data.fields, appSettings);
    } else if (contentType === `componentSpacer`) {
      return new SpacerComponentModel(data.fields, appSettings);
    } else if (contentType === `componentApplicationFee`) {
      return new ApplicationFeeComponentModel(data.fields, appSettings);
    } else if (contentType === `componentPricingBlock`) {
      return new PricingBlockComponentModel(data.fields, appSettings);
    } else {
      return null;
    }
  }
}
